/* eslint-disable */
export default [
  {
    title: 'Início',
    icon: 'HomeIcon',
    route: 'fut-home',
    resource: 'assinante-futures',
  },
  {
    title: 'Ordens abertas',
    icon: 'ShoppingCartIcon',
    route: 'fut-ordem-aberta',
    resource: 'assinante-futures',
  },
  {
    title: 'Posições',
    icon: 'TrendingUpIcon',
    route: 'fut-posicao',
    resource: 'assinante-futures',
  },
  {
    title: 'Transferência',
    icon: 'CornerDownRightIcon',
    route: 'fut-transfer',
    resource: 'assinante-futures',
  },
  {
      title: 'Meus agentes',
      icon: 'UsersIcon',
      route: 'fut-meu-agente',
      resource: 'assinante-futures',
  },
  {
    title: 'Relatórios',
    icon: 'ListIcon',
    children: [
        {
            title: 'Fechamento',
            route: 'fut-relatorio-fechamento',
            resource: 'assinante-futures',
        },
    ],
  },
  {
    title: 'Sinais',
    icon: 'ActivityIcon',
    route: 'fut-relatorio-sinal',
    resource: 'assinante-futures',
  },
  {
    title: 'Agente',
    icon: 'UserIcon',
    children: [
      {
        title: 'Assinantes',
        route: 'fut-agente-assinante',
        resource: ['agente-futures', 'agente-futures-robo'],
      },
      {
        title: 'Desempenho assinantes',
        route: 'fut-agente-assinante-desempenho',
        resource: ['agente-futures', 'agente-futures-robo'],
      },
      {
        title: 'Nova operação',
        route: 'fut-agente-nova-operacao',
        resource: 'agente-futures',
      },
      {
        title: 'Operações abertas',
        route: 'fut-agente-operacao-aberta',
        resource: 'agente-futures',
      },
      {
        title: 'Aprovar operações',
        route: 'fut-monitor-aprovar-operacao',
        resource: 'agente-futures-robo',
      },
      {
        title: 'Monitorar operações',
        route: 'fut-monitor-operador-estrategia-instancias',
        resource: 'agente-futures-robo',
      },
    ],
  },
  {
    title: 'Indicações',
    icon: 'Share2Icon',
    children: [
      {
        title: 'Dashboard',
        route: 'indicacao',
        resource: 'multinivel',
      },
      {
        title: 'Extrato',
        route: 'indicacao-extrato',
        resource: 'multinivel',
      },
      {
        title: 'Rede',
        route: 'indicacao-rede',
        resource: 'multinivel',
      },
      {
        title: 'Saque',
        route: 'indicacao-saque',
        resource: 'multinivel',
      },
    ],
  },
  {
    title: 'Ajustes',
    icon: 'SettingsIcon',
    route: 'conta-configuracao',
    resource: 'assinante-futures',
  },
  {
    title: 'Controle',
    icon: 'UserIcon',
    children: [
      {
        title: 'Assinantes',
        icon: 'UserIcon',
        route: 'controle-assinante',
        resource: 'administrador',
      },
    ],
  },
  {
    title: 'Tutoriais',
    route: 'tutorial',
    icon: 'BookOpenIcon',
    resource: 'assinante-futures',
  },
  {
    title: 'Empresa',
    icon: 'Share2Icon',
    children: [
      {
        title: 'Distribuição extrato',
        route: 'empresa-financeiro-distribuicao-extrato',
        resource: 'empresa',
      },
      {
        title: 'Distribuição saque',
        route: 'empresa-financeiro-distribuicao-saque',
        resource: 'empresa',
      },
    ],
  },
]
